import type { IconName } from "@similarweb/icons";

import { getIsKeywordsLocked } from "app/pages/activation/helpers/getIsLockedComponent";

export enum TopicMenu {
    Edit = "edit",
    Delete = "delete",
    DownloadExcel = "downloadExcel",
}

export const MENU_ITEMS = [
    {
        id: TopicMenu.Edit,
        title: "activation.widget.topics.list.single.menu.edit.text",
        icon: "edit-icon" as IconName,
        enabled: true,
    },
    {
        id: TopicMenu.Delete,
        title: "common.remove",
        icon: "delete" as IconName,
        enabled: true,
    },
    {
        id: TopicMenu.DownloadExcel,
        title: "activation.widget.topics.list.single.menu.downloadExcel.text",
        icon: "excel" as IconName,
        enabled: !getIsKeywordsLocked(),
    },
];

export const MENU_WIDTH = 200;
